<template>
  <div class="contents master-maintenance-container">

    <h2>マスタ管理</h2>

    <div class="container koyoukeiyaku-menu page-menu-items">

      <div class="menu">
        <div class="col-item">
          <router-link :to="{
            name: RouterConst.MST_SYOUNIN_GROUP_SEARCH
          }">承認グループの管理
          </router-link>
          <p>承認グループの新規作成、検索、編集をします</p>
        </div>
        <div class="col-item">
          <router-link :to="{
            name: RouterConst.MST_BUKA_SEARCH
          }">部課・就業場所の管理
          </router-link>
          <p>部課・就業場所の新規作成、検索、編集をします</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { RouterConst } from '@/const/Router';

export default defineComponent({
  setup() {

    return {
      RouterConst,
    }
  },
  components: {
  }
})

</script>


<style lang="scss" scoped>
@import "@scss/components/menu-items.scss";
</style>
